export default __webpack_public_path__ + "static/media/044-use handkerchief.136e2603.svg";